export enum LanguageEnum {
  English = 'en',
  Arabic = 'ar',
}

export enum VerificationValues {
  Verified = 'Verified',
  NotVerified = 'NotVerified',
}
export enum RolesStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum GeneralStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
export enum MultiplePlantRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum MenuProps {
  Write = 'isWrite',
  Read = 'isRead',
  Update = 'isUpdate',
  Delete = 'isDelete',
  Approve = 'isApprove',
  Reject = 'isReject',
  Activate = 'isActivate',
  Deactivate = 'isDeactivate',
}

export enum JWTTokenValidation {
  Valid = 'valid',
  NotFound = 'NotFound',
  Expired = 'Expired',
}

export enum PermissionKeys {
  Groups = 'Groups',
  Plants = 'Plants',
  Departments = 'Departments',
  ManageUsers = 'Manage Users',
  ManageRoles = 'Manage Roles',
  UserAuthorized='User Authorized',
  Employees = 'Employees',
  MultiplePlantRequests = 'Multiple Plant Requests',
  MachineMap = 'Machine Map',
  ManageMenu ='Manage Menu',
  GeneralCategory = 'General Category',
  InputOutputLot = 'Production Input/Output Lot Report',
  IotConsole = 'IOT Console',
  CitiesAndCountries = 'Cities & Countries',
  SupplierDetailConfiguration = 'Supplier Detail Configuration',
  ProductConfiguration = 'Product Configuration',
  MachineParameters = 'Machine Parameters',
  ProcessReadingInterval = 'Process Reading Interval',
  ProcessControl = 'Process Control',
  QualityParameters = 'Quality Parameters',
  NCRActionMaster = 'NCR Action Master',
  CoaCustumer = 'COACustomer',
  RawMaterialQualityChecks = 'Raw Material Quality Checks',
  RMQCVerifyReport = 'RMQC Verify Report',
  PlantModel = 'Plant Model',
  VariableManagement = 'Machine Parameters',

  // ----------- Material --------------
  MaterialMaster = 'Material Master',
  MaterialDefination = 'Material Definition',
  MaterialExecution = 'Material Execution',
  MaterialAnalysisComparison = 'Material Analysis Comparison',
  // ----------- End -------------------

  QualitySamplingInterval = 'Quality Sampling Interval',
  QualityControl = 'Quality Control',
  CrewSchedule = 'Crew Schedule',
  OEEConfiguration = 'OEE Configuration',
  SFDCConfiguration = 'SFDC Configuration',
  DTConfiguration = 'DT Configuration',
  ProductionOrder = 'Production Order',
  ProductionOrderPermission = 'Production Order Permission',
  ProductionStartUpdate = 'Production Start Update',
  ERPMachineMapping = 'ERP MachineMapping',
  ERPPlantMapping = 'ERP PlantMapping',
  ERPProductionOrder = 'ERP Production Order',
  WasteSupervisoryScreen = 'Waste Supervisory Screen',
  QCBox = 'QCBox',
  ShopFloorData = 'Shop Floor Data',
  Detector = 'Detector',
  PestPriority = 'Priority',
  ItemBOMConfiguration = 'Item BOM Configuration',
  Recommendation = 'Recommendation',
  ChecklistConfiguration = 'Checklist Configuration',
  QCParameterApprovalReport = 'QC Parameter Approval Report',
  BatchConfiguration_UnitLinking = 'BatchConfiguration_UnitLinking',
  ChecklistExecution = 'Checklist Execution',
  ChecklistHistory = 'Checklist History',
  StationConfiguration = 'StationConfiguration',
  ZoneFloor = 'ZoneFloor',
  DetectorSymbol = 'DetectorSymbol',
  PestTypeSpecies = 'PestTypeSpecies',
  Pesticides = 'Pesticides',
  QXMatrix = 'QX Matrix',
  QXMatrixReport = 'QX Matrix Report',
  InfestationLevel = 'InfestatioLevel',
  VisitRequest = 'Visit Request',
  PredefinedReasons = 'PredefinedReasons',
  Maps = 'Maps',
  ShopFloorDataFood = 'Shop Floor Data',
  WasteCFMapping = 'UoM Converter',
  LanguageMaster = 'Language Master',
  UnitOfMeasure = 'Unit Of Measure Configuration',
  CustomerManagement = 'Customer Management',
  CostMasterBreakdown = 'Cost Master Breakdown',
  NCRManagement = 'NCR Management',
  CustomerComplaintManagement = 'Customer Complaint Management',
  NcrActionMaster = 'Ncr Action Master',
  SortingReport = 'Sorting Report',
  ImmediateAction = 'Immediate Action',
  ApproveImmediateActions = 'Approve Immediate Actions',
  BatchConfiguration = 'Batch Configuration',
  CustomerUsers = 'Customer Users',
  MaterialAVailabilityCheck = 'Material AVailability Check',
  RCASWOTAnalysis = 'RCA Analysis',
  PalletBarcodeTracking = 'Pallet Barcode Tracking',
  CompanyProfile = 'Company Profile',
  MasterData = 'Master Data',
  AssetCalibration = 'Asset Calibration',
  RMQCQualityParameters = 'RMQC Quality Parameters',
  BatchQCPrepration = 'Batch QC Prepration',
  AdminDashboard = 'Admin DashBoard',
  QualityControlDepartment = 'Quality Control Department',
  WhatsappConfiguration = 'WhatAppConfig',
  ManageModuleLicenses = 'Manage Module Licenses',
  KPITargetDownload = 'Kpi Target Download',
  MachineDashboard = 'Machine Dashboard',
  RMQC = 'RMQC',
  BatchLinking = 'Batch Linking',
  OLEMasterData = 'OLE Master Data',
  ExecutionDetail = 'Execution Detail',
  WarehouseReceived = 'Warehouse Pallet Received',
  PalletBox = 'PalletBox',

  StaffAttendence = 'Staff Attendence',
  FTEMicroLevel = 'FTE Micro Level',
  BatchPreparation = 'Batch Preparation',
  BatchTimingSheet = 'Batch Timing Sheet',
  DowntimeReport = 'Downtime',
  ProductionOrderHoney = 'Production Order Honey', // Production Plan (in Production Order Management)
  ProcessingTimeLogSheet = 'Processing Time Log Sheet',
  MicroLevelDashboard = 'FTE Micro Dashboard',
  FteMicroTask = 'FteMicroTask',
  SFDCHoney = 'SFDC',
  AssetMasterData = 'Asset Master Data',
  ShopFloorDataHoney = 'Shop Floor Data Honey',
  MachineParameterSPC = 'Machine Parameter SPC',
  QualityParameterSPC = 'Quality Parameter SPC',
  ParameterAnalysisDashboardSPC = 'Parameter Analysis Dashboard SPC',
  RawMaterialQualityChecksLogging = 'Raw Material Quality Checks Interval',
  ERPIntegrationStatus = 'ERP Integration Status',
  GoldenBatchAnalysis = 'Golden Batch Analysis',
  CustomizedDashboard = 'Customized Dashboard',
  CustomerSurvey = 'Customer Survey',
  ProductionReport = 'Production Report',
  EventConfiguration = 'Event Configuration',
  LotCodePalletPrint = 'Lotcode/Pallet Print',
  batchFlowConfiguration = 'Batchflow Configuration',
  NCRSkipWindow = 'NCR Skip Window',
  DataExtraction = 'Data Extraction',
  PageCountdasshboard = 'Page Count Dashboard',
  Warehouse = 'Warehouse',
  Coedashboard = 'COE DashBoard',
  SamplingWindow = 'Sampling Window',
  OperatorExecutionWindow = "Operator Execution Window",
}

export enum PermissionTypes {
  IsWrite = 'isWrite',
  IsRead = 'isRead',
  IsUpdate = 'isUpdate',
  IsDelete = 'isDelete',
  IsReject = 'isReject',
  IsActivate = 'isActivate',
  IsApprove = 'isApprove',
  IsDeactivate = 'isDeactivate',
}

export enum SortDirection {
  None = '',
  Ascending = 'asc',
  Descending = 'desc',
}

export enum DaysOfWeek {
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
}

export enum Weeks {
  first = 'first',
  second = 'second',
  third = 'third',
  fourth = 'fourth',
  last = 'last',
}

export enum Months {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export enum TaskRepeated {
  NotRepeated = 'NotRepeated',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quaterly = 'Quaterly',
  Yearly = 'Yearly',
}

export enum NotificationType {
  MULTIPLE_PLANT_REQUEST = 'MULTIPLE_PLANT_REQUEST',
  PLANT_REQUEST_SENT_APPROVE = 'PLANT_REQUEST_SENT_APPROVE',
  PLANT_REQUEST_SENT_REJECT = 'PLANT_REQUEST_SENT_REJECT',
}

export enum FilterDashboards {
  ThisDay = 'This Day',
  Yesterday = 'Yesterday',
  CurrentMonth = 'Current Month',
  LastMonth = 'Last Month',
  Last30Day = 'Last 30 Day',
  CustomRange = 'Custom Range',
}

export enum VariantEnum {
  WATER_VARIANT = 'WATER_VARIANT',
  HONEY_VARIANT = 'HONEY_VARIANT',
  FROZEN_FOODS_VARIANT = 'FROZEN_FOODS_VARIANT',
  FRESH_FOODS_VARIANT = 'FRESH_FOODS_VARIANT',
  PACKAGING_VARIANT = 'PACKAGING_VARIANT',
  DIARY_VARIANT = 'DIARY_VARIANT',
}

export enum CommonMessages {
  SFDC_CALCULATION_VARIABLE_MESSAGE = 'This field is auto-calculated and cannot be edited.'
}

export enum PriorityLevel {
  High = 3,
  Medium = 2,
  Low = 1
}
